import * as React from "react";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useAppStore } from "../../appStore";
import { deepOrange } from "@mui/material/colors";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  ListItemIcon,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ReportIcon from "@mui/icons-material/Report";
import { useState } from "react";
import { api_url } from "../../apiUtils";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { getDeviceId } from "../utils/DeviceId";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

export default function ProfileBadge() {
  const { profileData } = useAppStore();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = React.useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // dialog
  const handleOpenLogoutDialog = () => {
    setIsLogoutDialogOpen(true);
  };

  const handleCloseLogoutDialog = () => {
    setIsLogoutDialogOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const userName = profileData?.name.charAt(0);

  const handleLogout = async () => {
    const accessToken = sessionStorage.getItem("accesstoken");
    const sessionToken = sessionStorage.getItem("sessionId");
    const deviceId = getDeviceId();

    // 👇 List of extra games to end session for
    const extraGames = ["dice-roll", "spin-and-win", "direction-wheel-game"];

    try {
      // 🛑 1. End each game's session
      // for (const gameId of extraGames) {
      //   await axios.post(
      //     `${api_url}game/extra-game/end-session`,
      //     { sessionToken, deviceId, gameId },
      //     {
      //       headers: { accessToken },
      //     }
      //   );
      // }

      // ✅ 2. Logout user
      const response = await axios.post(
        `${api_url}auth/logout`,
        {},
        { headers: { accessToken } }
      );

      const result = response.data;

      if (result.status === "success") {
        sessionStorage.clear();
        sessionStorage.removeItem("sessionId");
        navigate("/");
        toast.success("Logged out successfully.");
        setIsLogoutDialogOpen(false);
      }
    } catch (error) {
      console.error("Logout Error:", error.message);
      toast.error("Logout failed. Please try again.");
    }
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            // background: { xs: "none", md: "#ffe0b2" },

            // borderRadius: { xs: 0, md: 3 },
            // p: { xs: 0, md: 0.5 },
          }}
          onClick={handleClick}
        >
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
          >
            <Avatar sx={{ bgcolor: deepOrange[500] }}>
              {userName.toUpperCase()}
            </Avatar>
          </StyledBadge>

          <Box
            ml={1}
            sx={{
              display: { xs: "none", lg: "flex" },
              alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                color: "#212762",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
              }}
            >
              Hello,{" "}
              <p style={{ fontFamily: "cursive", marginLeft: "2px" }}>
                {profileData?.name.split(" ")[0]?.[0].toUpperCase() +
                  profileData?.name.split(" ")[0]?.slice(1).toLowerCase()}
              </p>{" "}
              👋
            </Typography>
            <KeyboardArrowDownIcon sx={{ color: "#212762" }} />
          </Box>
        </Box>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            sx: {
              width: 220,
              mt: 1.5,
              borderRadius: 3,
              boxShadow: 4,
              px: 1,
              py: 1,
            },
          }}
        >
          <List disablePadding>
            <ListItem
              sx={{
                borderRadius: 2,
                transition: "all 0.3s",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              onClick={() => {
                handleClose();
                navigate("/profile");
              }}
            >
              <ListItemIcon>
                <StyledBadge overlap="circular">
                  <Avatar sx={{ bgcolor: deepOrange[500], fontSize: 14 }}>
                    {userName.toUpperCase()}
                  </Avatar>
                </StyledBadge>
              </ListItemIcon>
              <ListItemText
                primary="My Profile"
                primaryTypographyProps={{ fontWeight: 500, fontSize: 15 }}
              />
            </ListItem>

            <Divider sx={{ my: 1 }} />

            <ListItem
              sx={{
                borderRadius: 2,
                transition: "all 0.3s",
                background:
                  "linear-gradient(45deg, #FF5252,rgb(243, 181, 193))", // Gradient background
                "&:hover": {
                  background: "linear-gradient(45deg, #FF1744, #FF5252)", // Inverted gradient on hover
                  boxShadow: "0 4px 10px rgba(255, 0, 0, 0.4)", // Soft shadow on hover
                },
                padding: "8px 16px",
              }}
              onClick={handleOpenLogoutDialog}
            >
              <ListItemIcon>
                <LogoutIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{
                  fontWeight: 600,
                  color: "white",
                  fontSize: 15,
                }}
              />
            </ListItem>
          </List>
        </Popover>
      </Stack>

      <Dialog
        open={isLogoutDialogOpen}
        onClose={handleCloseLogoutDialog}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle
          id="logout-dialog-title"
          sx={{ fontWeight: "bold", display: "flex", alignItems: "center" }}
        >
          <ReportIcon sx={{ color: "red", mr: 1, ml: -0.5 }} />
          Confirm Logout
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure, you want to log out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseLogoutDialog}
            color="primary"
            sx={{ textTransform: "capitalize" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            color="error"
            sx={{ textTransform: "capitalize" }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
